/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SalesArticleDto } from '../../models/sales-article-dto';

export interface ApiProductsquerySalesarticlesUrlIdDetailsGet$Plain$Params {
  urlId: number;
}

export function apiProductsquerySalesarticlesUrlIdDetailsGet$Plain(http: HttpClient, rootUrl: string, params: ApiProductsquerySalesarticlesUrlIdDetailsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SalesArticleDto>> {
  const rb = new RequestBuilder(rootUrl, apiProductsquerySalesarticlesUrlIdDetailsGet$Plain.PATH, 'get');
  if (params) {
    rb.path('urlId', params.urlId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SalesArticleDto>;
    })
  );
}

apiProductsquerySalesarticlesUrlIdDetailsGet$Plain.PATH = '/api/productsquery/salesarticles/{urlId}/details';
